/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {FC, useEffect, useState, useMemo} from 'react'
import {TabLavanderiaModel} from '../../../../../../models'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {PointModel, SelectModel} from '../../../../model'
import {getPoint} from '../../../../services'
import {MasiveUploadPoint} from '../form/MasiveUploadPoint'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {useCompany, useClient, useSite, useCamp} from '../../../../../central/hooks'
import {getMasterService} from '../../../../../central/services'
import useTableForMaster from '../../../../hooks/useTableForMaster'
const TablePoint: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    clearSelected,
    pagination,
    updateTable,
    setUpdateTable,
    selectedOn,
    clearTable,
    setClearTable,
  } = useKTable()
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useLavanderia()
  const {searchValues, clearSearchValues} = useKhipu()
  const [status, setStatus] = useState<SelectModel[]>([])
  const [typeAdmin, setTypeAdmin] = useState<SelectModel[]>([])
  const {statusService, getStatusServiceList} = useTableForMaster()
  const {companyList, getCompanyList} = useCompany()
  const {clientList, getClientList} = useClient()
  const {siteList, getSiteList} = useSite()
  const {campList, getCampList} = useCamp()
  const getStatus = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'EstadoLavanderia',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
        codigo: master.codigo,
      }))
      setStatus(mappedMaster)
    } catch (error) {
      setStatus([])
    }
  }
  const getTypeAdmin = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoAdministracion',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.codigo,
        label: master.nombreCorto,
        codigo: master.codigo,
      }))
      setTypeAdmin(mappedMaster)
    } catch (error) {
      setTypeAdmin([])
    }
  }
  const getPointList = async () => {
    setLoading(true)
    const response = await getPoint(searchValues, pagination.currentPage)
    setData(response.data.data)
    setLoading(false)
  }
  useEffect(() => {
    getCompanyList()
    getClientList()
    getSiteList()
    getCampList()
    getStatus()
    getTypeAdmin()
    getStatusServiceList()
    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    getPointList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination])

  useEffect(() => {
    if (Object.keys(searchValues).length === 0) {
      getPointList()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValues])
  const handleViewPanel = (data: any) => {
    const getRow = data.row
    const getArrows = data.data
    const getData = getArrows[getRow.index]
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      showPanel: true,
      idToEdit: getData.id,
      content: {
        ...currentTabItem.content,
        detailPanel: 'tab-point',
      },
      idToDelete: '',
    }
    changeCurrentTabItem(obj)
    clearSelected()
  }

  const handleGetId = (id: any) => {
    let idChange = id === currentTabItem.idToDelete ? '' : id
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      showPanel: false,
      idToDelete: idChange,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }

  const columns: Column<PointModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} showSelect={false} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCellNonMultiple
            id={props.data[props.row.index].id}
            clickHandler={handleGetId}
          />
        ),
      },

      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Campamento'
            name='campamentoId'
            selecteable
            data={campList}
          />
        ),
        accessor: 'nombreCampamento',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Lavandería'
            name={'nombre'}
            searcheable
          />
        ),
        accessor: 'nombre',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Capacidad Instalada'
            name={'capacidadInstalada'}
            searcheable
          />
        ),
        accessor: 'capacidadInstalada',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Capacidad Maquinarias'
            name={'cantidadMaquinas'}
            searcheable
          />
        ),
        accessor: 'cantidadMaquinas',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipos de Administración'
            name='tipoAdministracion'
            selecteable
            data={typeAdmin}
          />
        ),
        accessor: 'tipoAdministracion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Estado'
            position='left'
            name={'estado'}
            selecteable
            data={statusService}
          />
        ),
        accessor: 'estado',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Compañía'
            name={'companiaId'}
            selecteable
            data={companyList}
          />
        ),
        accessor: 'nombreCompania',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cliente'
            name={'clienteId'}
            selecteable
            data={clientList}
          />
        ),
        accessor: 'nombreCliente',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Site'
            name={'siteId'}
            selecteable
            data={siteList}
          />
        ),
        accessor: 'site',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions',
        Cell: ({...props}) => (
          <>
            {isAllowed('EDITAR') && (
              <div
                className='d-flex justify-content-center flex-shrink-0'
                onClick={() => handleViewPanel(props)}
              >
                <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                  <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
                </a>
              </div>
            )}
          </>
        ),
      },
    ],
    [companyList, clientList, siteList, campList, typeAdmin, status, selectedOn],
  )

  useEffect(() => {
    setInitialPagination()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.loadingTable])

  const setInitialPagination = async () => {
    const {data: response} = await getPoint({}, pagination.currentPage)
    setPagination({
      perPage: 10,
      currentPage: 1,
      totalResults: response.total,
    })
  }

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {}, [data])

  useEffect(() => {
    if (updateTable) {
      clearSelected()
      getPointList()
      setUpdateTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTable])
  useEffect(() => {
    if (clearTable) {
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])
  return (
    <>
      {isAllowed('LISTAR') && (
        <KTCard shadow className='w-100'>
          <KTable data={data} columns={columns} classNameProps='dataTablecentral' />
          {loading ? <KTableLoading title='Cargando...' /> : null}
        </KTCard>
      )}
    </>
  )
}

const TablePointWrapper = () => {
  const {isAllowed} = useLavanderia()
  return (
    <KTableProvider>
      <div className='sdx_content_tab_panel'>
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            <Tab className={'sdx_sub_tab_panel_option'}>Listado de Puntos</Tab>
            {isAllowed('MASIVO') && <Tab className={'sdx_sub_tab_panel_option'}>Carga Masiva</Tab>}
          </TabList>
          <TabPanel>
            <TablePoint />
          </TabPanel>
          {isAllowed('MASIVO') && (
            <TabPanel>
              <MasiveUploadPoint />
            </TabPanel>
          )}
        </Tabs>
      </div>
    </KTableProvider>
  )
}

export {TablePointWrapper}
